import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["hamburger", "menu", "submenu"]

  initialize() {
    this.mediaquery = window.matchMedia("(max-width: 1024px)")
  }

  toggleMenu() {
    if (!this.mediaquery.matches) { return }
    this.menuTarget.classList.toggle("hidden")
    this.menuTarget.classList.toggle("flex")
  }

  closeMenu() {
    if (!this.mediaquery.matches) { return }
    this.menuTarget.classList.add("hidden")
    this.submenuTargets.forEach(submenu => submenu.classList.add("hidden"))
  }

  toggleSubcategory(event) {
    if (!this.mediaquery.matches) { return }
    event.preventDefault()
    event.stopPropagation()
    const subcategory = event.currentTarget.querySelector(".subcategory") || event.currentTarget.nextElementSibling
    if (subcategory) {
      subcategory.classList.toggle("hidden")
    }
  }

  toggleProductsMenu(event) {
    if (!this.mediaquery.matches) { return }
    event.preventDefault()
    event.stopPropagation()
    const productsMenu = event.currentTarget.nextElementSibling
    if (productsMenu) {
      productsMenu.classList.toggle("hidden")
      productsMenu.classList.toggle("block")
    }
  }

  goToCategory(event) {
    if (!this.mediaquery.matches) { return }
    event.preventDefault()
    const url = event.currentTarget.getAttribute("href")
    if (url) {
      Turbo.visit(url, { action: "replace" })
    }
  }
}
